import { Component, inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Observable, of } from 'rxjs';
import FieldsConstants from 'src/app/common/fields.constants';
import { MessageLevel } from 'src/app/interfaces';
import { DialogActionTypes } from 'src/app/notifications/dialogs/dialogs.enum';
import { NotificationState } from 'src/app/notifications/notifications.state';
import { ValidationService } from 'src/app/services/validation.service';
import { DIALOG_DEFAULT_DATA } from '../dialog-default/dialog-default.component';

@Component({
  selector: 'app-dialog-deactivate-account',
  templateUrl: './dialog-deactivate-account.component.html',
  styleUrls: ['./dialog-deactivate-account.component.scss'],
})
export class DialogDeactivateAccountComponent extends NotificationState {
  protected notificationLevel: MessageLevel = 'INFO';

  private validationService = inject(ValidationService);

  public readonly modalArguments = inject(DIALOG_DEFAULT_DATA);
  public readonly hasUnsavedChanges$: Observable<boolean> = of(false);

  public confirmActionButton: string = DialogActionTypes.CONFIRM_ACTION;

  public maxReasonLength = FieldsConstants.DEACTIVATE_ACCOUNT_REASON_MAX_LENGTH;

  public deactivateAccountReason: FormControl<string> = new FormControl('', [
    Validators.required,
    Validators.minLength(0),
    Validators.maxLength(this.maxReasonLength),
    ...this.validationService.getValidators('noWhiteSpacesOnly'),
  ]);

  public actionsHandler(action: DialogActionTypes): void {
    this.dialogActions[action]();
  }

  public submit(): void {
    this.confirmAction();
  }

  public override confirmAction(): void {
    this.activeModal.close(this.deactivateAccountReason.value);
  }

  public get isValid(): boolean {
    return this.deactivateAccountReason.valid;
  }

  public onBlur(): void {
    this.deactivateAccountReason.setValue((this.deactivateAccountReason.value || '').trim());
  }
}
